import './loader.scss';

export default {
  name: 'Loader',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
};
